import ProjectInvestmentBoard from './ProjectInvestmentBoard';

// Bucket B opt 2 — real-estate contributions: projects seeking development
// funding, each with the developer-set contribution range.
export default function ContributionsPage() {
  return (
    <ProjectInvestmentBoard
      variant="contribute"
      icon="ri-checkbox-circle-line"
      titleEn="Real-estate contributions"
      titleAr="المساهمات العقارية"
      subtitleEn="Licensed projects seeking development funding - contribute within the developer's set range."
      subtitleAr="مشاريع مرخّصة تبحث عن تمويل للتطوير - ساهم ضمن الحصة التي حدّدها المطوّر."
    />
  );
}
